export const speakerCardSchema = () => ({
  title: 'Speaker card',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['heading', 'showEmail'],
    },
  ],
  properties: {
    heading: {
      title: 'Heading',
      type: 'string',
    },
    showEmail: {
      title: 'Show email address',
      type: 'boolean',
    },
  },
  required: [],
});
export default speakerCardSchema;
